import isEmpty from 'lodash/isEmpty'
import * as Constants from './constants'
import * as Types from './types'

const redirectedUrls: Types.Redirect[]  = [
  {
    new: '/community/config',
    old: '/community-config',
    type: 'prefix',
  },
  {
    new: '/content/filter-group',
    old: '/filter-group',
    type: 'prefix',
  },
  {
    new: '/newsletter/',
    old: '/newsbrief/',
    type: 'prefix',
  },
  {
    new: '/content/source',
    old: '/source-config',
    type: 'prefix',
  },
  {
    new: '/reports/daily',
    old: '/reports/today',
    type: 'prefix',
  },
  {
    new: Constants.SUBSCRIBERS_URL_HOME,
    old: '/members',
    type: 'full',
  },
  {
    new: Constants.SUBSCRIBERS_SUBSCRIBER_DETAIL_URL,
    old: '/members/member-details',
    type: 'prefix',
  },
  {
    new: Constants.ADMIN_COMMUNITIES_URL,
    old: '/communities',
    type: 'full',
  },
  {
    new: Constants.ADMIN_FEEDBACK_URL,
    old: '/feedback',
    type: 'full',
  },
  {
    new: Constants.ADMIN_NEWSBRIEF_COUNTS_URL,
    old: '/newsbriefs',
    type: 'full',
  },
  {
    new: Constants.ADMIN_NEWSBRIEF_COUNTS_URL,
    old: '/admin/newsbriefs',
    type: 'full',
  },
  {
    new: Constants.REPORTS_ENGAGEMENT_URL,
    old: '/engagement',
    type: 'full',
  },
  {
    new: Constants.REPORTS_OLD_ADVERTISING_URL,
    old: '/reports/promotions',
    type: 'full',
  },
]

const newUrl = (pathname: string, redirect: Types.Redirect): string => {
  switch (redirect.type) {
    case 'full':
      return pathname === redirect.old ? redirect.new : null
    case 'prefix':
      if (pathname.startsWith(redirect.old)) {
        return pathname.replace(redirect.old, redirect.new)
      } else {
        return null
      }
    default: return null
  }
}

export const redirectUrl = (pathname: string): string => {
  const newUrls = redirectedUrls.map((u: Types.Redirect) => newUrl(pathname, u)).filter((s: string) => !isEmpty(s))
  if (isEmpty(newUrls)) {
    return null
  } else {
    return newUrls[0]
  }
}



// WEBPACK FOOTER //
// ./src/components/menu/redirects.ts